import {TFunction} from 'react-i18next';
import {formatDateTime} from 'i18n/localeDateFormat';
import i18n from 'i18n/i18n';
import Excel from 'exceljs';
import {
	renderHeaderXL,
	createZIPXL,
	IHTMLXL,
	renderHTMLExcel,
	cleanHTMLExcel,
} from './ExcelExportCommon';
import {RegulatoryDocument} from 'types';

interface IExcel {
	(
		entityListiRegDocs: any[],
		columnNames: string[],
		t: TFunction,
	): Promise<void>;
}

export const handleClickVoProPage: IExcel = async (
	entityListiRegDocs,
	columnNames,
	t,
) => {
	const arrRegDocFilt = entityListiRegDocs;

	const strPageName = t('RegulatoryDocuments', {
		ns: 'appShell/sidenavigation',
		keyPrefix: 'SideNavigation',
	});

	const arrColWidth = [
		60,
		40,
		...new Array(3).fill(25),
		40,
		40,
		...new Array(10).fill(25),
	];
	const workbook = new Excel.Workbook();
	const sheet = workbook.addWorksheet('TRACE_' + strPageName);
	renderHeaderXL(workbook, sheet, arrColWidth, strPageName, t);

	let intRowCount = 4;
	let row = sheet.getRow(intRowCount);
	row.font = {
		bold: true,
		name: 'Porsche Next TT',
		size: 10,
		color: {argb: 'FFFFFFFF'},
	};
	sheet.addTable({
		name: 'tableVoPro',
		ref: 'B' + String(intRowCount),
		style: {
			showRowStripes: true,
		},
		columns: columnNames.map(x => {
			return {name: x, filterButton: true};
		}),
		rows: [],
	});

	intRowCount++;
	const table = sheet.getTable('tableVoPro');

	let arrHTMLXL: IHTMLXL[];
	let arrHTMLXLClean: IHTMLXL[];
	const tempDivElement = document.createElement('div');

	arrRegDocFilt.forEach((iRegDoc: RegulatoryDocument) => {
		arrHTMLXL = [];
		arrHTMLXLClean = [];
		tempDivElement.innerHTML = iRegDoc.summary
			? '<div>' + iRegDoc.summary + '</div>'
			: '<div></div>';
		renderHTMLExcel(tempDivElement.childNodes[0].childNodes, arrHTMLXL);
		cleanHTMLExcel(arrHTMLXL, arrHTMLXLClean);

		row = sheet.getRow(intRowCount);
		row.alignment = {wrapText: true, vertical: 'top'};
		row.getCell('I').alignment = {horizontal: 'left'};
		row.getCell('C').style.font = {
			underline: true,
			bold: false,
			color: {argb: '00B0F0'},
		};

		table.addRow([
			{richText: arrHTMLXLClean, wrapText: true, vertical: 'top'},
			{
				text: `${iRegDoc.regulation?.regulationNumber ?? ''} | ${iRegDoc.name}`,
				hyperlink: `${window.location.origin}/regulatoryDocuments/${iRegDoc.id}`,
			},
			iRegDoc.workflow.clearingTimestamp
				? formatDateTime(new Date(iRegDoc.workflow.clearingTimestamp), i18n)
				: '',
			iRegDoc.contactPersons.map(x => x.name).join(';\n'),
			iRegDoc.markets.map(x => x.name).join(';\n'),
			iRegDoc.mainKeywords.map(x => x.name).join(';\n'),
			iRegDoc.keywords.map(x => x.name).join(';\n'),
			t(iRegDoc.status, {
				ns: 'common/enums',
				keyPrefix: 'RegulatoryDocumentStatus',
			}),
			iRegDoc.dateEffective
				? formatDateTime(new Date(iRegDoc.dateEffective), i18n)
				: '',
			iRegDoc.dateNewTypes
				? formatDateTime(new Date(iRegDoc.dateNewTypes), i18n)
				: '',
			iRegDoc.dateNewRegistration
				? formatDateTime(new Date(iRegDoc.dateNewRegistration), i18n)
				: '',
			iRegDoc.comprehensive
				? formatDateTime(new Date(iRegDoc.comprehensive), i18n)
				: '',
			iRegDoc.modelYear ?? '',
			iRegDoc.phaseIn
				.map(
					x => `${formatDateTime(new Date(x.date), i18n)} (${x.status ?? ''})`,
				)
				.join(';\n'),
			iRegDoc.phaseOut
				.map(
					x => `${formatDateTime(new Date(x.date), i18n)} (${x.status ?? ''})`,
				)
				.join(';\n'),
			t(iRegDoc.workflow.status, {
				ns: 'common/enums',
				keyPrefix: 'WorkflowStatus',
			}),
		]);

		intRowCount++;
	});

	table.commit();
	const strZipName = strPageName;
	await createZIPXL(workbook, strZipName, t);
};
